




































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

import LoadingPannel from '@/components/LoadingPannel.vue';
import DialogWindow from '@/components/DialogWindow.vue';
import ContactUs from '@/components/ContactUs.vue';

import { WebSiteModule } from '@/store';
import Menu from './models/Menu';

// Глобальная BVI (подключается через <script> в index.html)
declare const bvi: any;

@Component({
    components: {
        LoadingPannel,
        DialogWindow,
        ContactUs
    }
})
export default class App extends Vue {
    private dialogFeedback = false;
    private fab = false;
    private emailDialog = false;
    private phoneDialog = false;

    // BVI
    private isBVIToggled = false;
    private bviInstance: any = null;
    private readonly bviStorageKey = 'bvi_enabled';

    // Мобильные состояния
    private mobileMenuOpen = false;
    private isMobile = false;

    private get overlay() {
        return WebSiteModule.state.Initializing;
    }

    private get mainMenuItems() {
        return WebSiteModule.state.MenuItems;
    }

    private extraPermissions = false;

    private get isAuthenticated() {
        this.extraPermissions = WebSiteModule.state.Identity.Roles.some(q => q === 'Admin' || q === 'ContentManager');
        return WebSiteModule.state.Identity.IsAuthenticated;
    }

    private get UserName() {
        return WebSiteModule.state.Identity.Name;
    }

    private get loading() {
        return WebSiteModule.state.Loading;
    }

    private set loading(v: boolean) {
        WebSiteModule.mutations.setLoading(v);
    }

    private get dialog() {
        return WebSiteModule.state.Dialog;
    }

    private set dialog(dialog: boolean) {
        WebSiteModule.mutations.setDialog(dialog);
    }

    private get error() {
        return WebSiteModule.state.Error;
    }

    private set error(e: any) {
        WebSiteModule.mutations.setError(e);
    }

    private navigate(row: Menu) {
        if (this.$route.fullPath !== row.FullPath) {
            this.$router.push(row.FullPath);
        }
        if (this.isMobile) {
            this.mobileMenuOpen = false;
        }
    }

    private activeClass(row: Menu) {
        if (this.$route.fullPath.startsWith(row.FullPath)) {
            return 'router-link-exact-active';
        }
        return '';
    }

    // ------- BVI: включение/выключение/переключение -------

    private hasBviLib(): boolean {
        try {
            return typeof bvi !== 'undefined' && bvi && typeof bvi.Bvi === 'function';
        } catch {
            return false;
        }
    }

    private enableBVI() {
        // Если библиотека есть — используем её
        if (this.hasBviLib()) {
            try {
                // Инициализируем единожды, автостарт — сразу включит режим
                if (!this.bviInstance) {
                    this.bviInstance = new bvi.Bvi({
                        // Контейнер можно не указывать (по умолчанию <body>), но оставим для изоляции
                        container: document.getElementById('app'),
                        autoStart: true,
                        // игнорируем элементы с data-bvi-ignore="true"
                        ignoreSelector: '[data-bvi-ignore="true"]',
                        // Дополнительно можно выставить дефолтные размеры/контраст
                        // theme: 'white', // black, white, blue, brown, green — если библиотека поддерживает
                        // fontSize: 18
                    });
                } else if (typeof this.bviInstance.start === 'function') {
                    // Если инстанс уже есть и библиотека поддерживает явный старт
                    this.bviInstance.start();
                }
            } catch (e) {
                console.warn('BVI: не удалось инициализировать библиотеку, используем CSS-режим.', e);
                document.body.classList.add('bvi-body');
            }
        } else {
            // Fallback: CSS-режим
            document.body.classList.add('bvi-body');
        }

        this.isBVIToggled = true;
        localStorage.setItem(this.bviStorageKey, '1');
        // ARIA для кнопки
        this.setAriaPressed(true);
    }

    private disableBVI() {
        try {
            if (this.bviInstance && typeof this.bviInstance.destroy === 'function') {
                this.bviInstance.destroy();
            }
        } catch (e) {
            console.warn('BVI: ошибка при отключении, продолжаем очистку классов.', e);
        }

        // Очистка CSS-режима
        document.body.classList.remove('bvi-body');

        this.bviInstance = null;
        this.isBVIToggled = false;
        localStorage.removeItem(this.bviStorageKey);
        this.setAriaPressed(false);
    }

    private toggleBVI() {
        if (this.isBVIToggled) {
            this.disableBVI();
        } else {
            this.enableBVI();
        }
    }

    private setAriaPressed(isOn: boolean) {
        const btn = document.getElementById('bvi-toggle-mobile');
        if (btn) {
            btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        }
    }

    public mounted(): void {
        // Определение мобильного устройства
        this.checkMobileDevice();
        window.addEventListener('resize', this.checkMobileDevice);

        // Восстановление BVI режима из localStorage
        if (localStorage.getItem(this.bviStorageKey) === '1') {
            // Дадим рендеру завершиться
            this.$nextTick(() => this.enableBVI());
        }

        this.$nextTick(async () => {
            await WebSiteModule.actions.loadMenuItems2();
            WebSiteModule.mutations.setRouter(this.$router);

            await WebSiteModule.actions.navigate(this.$route.fullPath);

            let redirect = false;
            if (WebSiteModule.state.ReturnUrl.length > 2) {
                if (this.$route.fullPath !== WebSiteModule.state.ReturnUrl) {
                    redirect = true;
                    setTimeout(() => {
                        const redirect = WebSiteModule.state.ReturnUrl;
                        this.$router.push(redirect);
                        WebSiteModule.mutations.setReturnUrl('');
                    }, 250);
                }
            }

            if (redirect) {
                setTimeout(() => {
                    WebSiteModule.mutations.setInitializing(false);
                }, 250);
            } else {
                WebSiteModule.mutations.setInitializing(false);
            }
        });
    }

    private checkMobileDevice() {
        this.isMobile = window.innerWidth < 768;
    }

    public beforeDestroy() {
        if (window) {
            window.removeEventListener('resize', this.checkMobileDevice);
        }
        // Корректно выключаем BVI
        this.disableBVI();
    }
}
